import React from 'react';
import { Link as GatsbyLink, navigate } from 'gatsby';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import clsx from 'clsx';
import { ILink } from 'utils/types/contentful';
import { returnLocalisedPath } from 'utils/globals';
import { withLocale } from 'utils/hocs';

export interface ILinkProps extends ILink {
  disabledLink?: boolean;
  children?: JSX.Element;
  className?: string | object | boolean;
  locale: string;
  obfuscate?: boolean;
  width?: string;
  target?: string;
}

export const Link = withLocale(
  ({
    children,
    className,
    disabledLink,
    icon,
    label,
    locale,
    slug,
    title,
    urlLink,
    obfuscate,
    width,
    rel,
    target,
  }: ILinkProps) => {
    const returnLinkContent = () => {
      if (children) {
        return children;
      } else if (label && icon) {
        return (
          <div className='flex justify-center items-center opacity-70 hover:opacity-100 transition-opacity duration-300 ease-in-out'>
            <div>
              <Label {...label} />
            </div>
            <div className='ml-2'>
              <Icon {...icon} />
            </div>
          </div>
        );
      } else if (label) {
        return (
          <span className='opacity-100 hover:opacity-80 transition-opacity duration-300 ease-in-out'>
            <Label {...label} />
          </span>
        );
      } else if (icon) {
        return <Icon {...icon} />;
      }
    };

    // INTERNAL LINKS
    if (slug && obfuscate) {
      return (
        // If link is obfuscated, return a span instead of a link with an onclick navigate function
        <span
          className={disabledLink ? 'cursor-not-allowed' : 'cursor-pointer'}
          onClick={() => navigate(returnLocalisedPath(locale[0], slug?.url))}>
          {returnLinkContent()}
        </span>
      );
    } else if (slug) {
      return (
        // Use Gatsby Link for internal links, and <a> for others
        <GatsbyLink
          className={clsx(className, width)}
          to={returnLocalisedPath(locale[0], slug?.url)}>
          {returnLinkContent()}
        </GatsbyLink>
      );
    }

    // EXTERNAL LINKS
    // Use <a> for external links
    return (
      <a
        title={title}
        rel={rel}
        target={target}
        className={clsx(
          className,
          disabledLink ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
        href={urlLink}>
        {returnLinkContent()}
      </a>
    );
  }
);
